/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './live-streaming-schedule.stache';
import can from 'can';
import FeedService from 'scripts/services/base-feed-service';

const liveFeedUrl = window.globalSettings.feeds.videos.liveScheduleUrl;
const liveScheduleByDayUrl = window.globalSettings.feeds.videos.liveScheduleByDayUrl;

Component.extend({
    tag: 'live-streaming-schedule',
    template: template,
    leakScope: false,
    viewModel: {
        scheduleDate: null,
        sponsorIsAvailable: false,
        define: {
            sponsor: {
                Type: can.Map,
                Value: null
            },
            liveVideoCards: {
                Type: can.List,
                Value: can.List
            }
        }
    },
    events: {
        inserted() {
            this.initFeedService();
            this.viewModel.bind('scheduleDate', () => {
                this.destroyFeedService();
                this.initFeedService();
            });
        },

        removed() {
            this.destroyFeedService();
        },

        initFeedService() {
            const scheduleDate = this.viewModel.attr('scheduleDate');
            let feedUrl = liveFeedUrl;
            if (scheduleDate) {
                feedUrl = can.sub(liveScheduleByDayUrl, {date: scheduleDate})
            }
            this.liveFeedService = new FeedService({feedUrl, fromCache: false});
            this.liveFeedService
                .on('data', (ev, data) => {
                    can.batch.start();
                    let liveVideoCards = this.viewModel.attr('liveVideoCards');
                    // add new elements
                    data.cards.filter((card) => {
                        let isNew = true;
                        liveVideoCards.each((liveCard) => {
                            if (card.channelIdentifier == liveCard.channelIdentifier) {
                                can.Map.keys(liveCard).forEach((key) => {
                                    liveCard.attr(key, card[key]);
                                });
                                isNew = false;
                            }
                        });
                        return isNew;
                    }).forEach((card) => {
                        liveVideoCards.push(card);
                    });
                    // clean old cards
                    liveVideoCards.filter((liveCard) => {
                        let remove = true;
                        data.cards.forEach((card) => {
                            if (remove && card.channelIdentifier == liveCard.channelIdentifier) {
                                remove = false;
                            }
                        });
                        return remove;
                    }).forEach((liveCard) => {
                        liveVideoCards.splice(liveVideoCards.indexOf(liveCard), 1);
                    });
                    can.batch.stop();

                    if (data && data.sponsor && (data.sponsor.image || _.get(data.sponsor, 'webImage.image'))) {
                        this.viewModel.attr('sponsorIsAvailable', true);
                        this.viewModel.attr('sponsor', data.sponsor);
                    }
                });
            this.liveFeedService.fetch();
        },

        destroyFeedService() {
            if (this.liveFeedService) {
                this.liveFeedService.destroy();
                this.liveFeedService = null;
            }
        }
    }

});
